import * as React from "react";
import { observer, inject } from "mobx-react";
import { Link, withRouter, RouteComponentProps, RouteProps } from "react-router-dom";
import { ReportStore } from "../../stores/ReportStore";
import SimpleReportComponent from "./SimpleSaleReportComponent";
import { SimpleHorseForSale } from "src/model/HorseForSale";
import { errorMessage } from "../common/Toast";

export interface Props {
    reportStore?: ReportStore;
}
export interface State {
    wasValidated: boolean;
    saleId: string | null;
    horseForSale: SimpleHorseForSale | null;
    reportContent: string;
}

@inject("reportStore")
@observer
export default class StakeEngagementsList extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            wasValidated: false,
            saleId: null,
            horseForSale: null,
            reportContent: ""
        };
    }

    onChangeSelectSale = (saleId: string) => {
        this.setState({ saleId });
    };

    onChangeSelectHorsesForSale = (horseForSale: SimpleHorseForSale) => {
        this.setState({ horseForSale });
    };

    generateReport = () => {
        const horseForSaleId = this.state.horseForSale == null ? 0 : this.state.horseForSale.id;
        this.props
            .reportStore!.getStakeEngagementListReport(parseInt(this.state.saleId!, 10), horseForSaleId)
            .then(response => this.setState({ reportContent: response }))
            .catch((error: any) => {
                errorMessage(error);
            });
    };

    formValidation = (): boolean => {
        return this.state.saleId !== null && this.state.saleId !== "" ? true : false;
    };

    submit = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        if (this.formValidation()) {
            this.setState({ wasValidated: false, reportContent: "" });
            this.generateReport();
        } else {
            this.setState({ reportContent: "", wasValidated: true });
        }
    };

    render() {
        return (
            <SimpleReportComponent
                title="Stake Engagements List"
                wasValidated={this.state.wasValidated}
                onSubmit={this.submit}
                onChangeSelectSale={this.onChangeSelectSale}
                onChangeSelectHorsesForSale={this.onChangeSelectHorsesForSale}
                content={this.state.reportContent}
                selectedSaleId={this.state.saleId}
                horseForSale={this.state.horseForSale}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/StakeEngagementsList.tsx